import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api`;

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('token');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
};

const skillService = {
  // Get all skills
  getAllSkills: async () => {
    try {
      const response = await axios.get(`${API_URL}/skills`, getAuthHeaders());
      return response.data;
    } catch (error) {
     
      throw error;
    }
  },

  // Add a new skill
  addSkill: async (name, label) => {
    try {
      const response = await axios.post(
        `${API_URL}/skills`,
        { name, label },
        getAuthHeaders()
      );
      return response.data;
    } catch (error) {
    
      throw error;
    }
  },

  // Update a skill
  updateSkill: async (id, name, label) => {
    try {
      const response = await axios.put(
        `${API_URL}/skills/${id}`,
        { name, label },
        getAuthHeaders()
      );
      return response.data;
    } catch (error) {

      throw error;
    }
  },

  // Delete a skill
  deleteSkill: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/skills/${id}`, getAuthHeaders());
      return response.data;
    } catch (error) {
     
      throw error;
    }
  }
};

export default skillService;
